export const isInTeams = () => { // app is running inside of MS Teams
    return window.location.ancestorOrigins && Array.from(window.location.ancestorOrigins).some((origin) => origin.includes("teams"));
}
